<template>
  <base-button
    :class="[sizeClasses, roundedClasses, bgClasses, hoverClasses]"
    class="ps-flex ps-items-center ps-justify-center ps-outline-none"
    @button-click="$emit('button-click')"
    :disabled="disabled"
    :stop="stop"
    :prevent="prevent"
  >
    <span
      :class="[colorClasses]"
      class="ps-pointer-events-none ps-flex ps-items-center"
    >
      <slot />
    </span>
  </base-button>
</template>

<script>
import BaseButton from './BaseButton'

export default {
  name: 'button-icon',
  props: {
    size: {
      type: Number,
      default: 12
    },
    rounded: {
      type: String,
      default: '0'
    },
    color: {
      type: String,
      default: 'ps-text-gray-400'
    },
    bgColor: {
      type: String
    },
    hoverColor: {
      type: String,
      default: 'brand-brown-800'
    },
    hoverBgColor: {
      type: String
    },
    disabled: Boolean,
    stop: Boolean,
    prevent: Boolean
  },
  components: {
    BaseButton
  },
  computed: {
    sizeClasses() {
      return `ps-w-${this.size} ps-h-${this.size}`
    },
    roundedClasses() {
      return `ps-rounded-${this.rounded}`
    },
    colorClasses() {
      return 'ps-text-gray-400 hover:ps-text-gray-800'
    },
    hoverClasses() {
      return `hover:ps-text-${this.hoverColor} hover:ps-bg-${this.hoverBgColor}`
    },
    bgClasses() {
      if (this.bgColor) {
        return `ps-bg-${this.bgColor}`
      }
    }
  }
}
</script>
